import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from "@angular/core";
import {FileResult} from "./file-result.interface";

@Directive({
  selector: "[appFileUpload]"
})
export class FileUploadDirective {

  @Output() imageSelected = new EventEmitter<FileResult>();
  @Output() imageSelectionCancelled = new EventEmitter<any>();

  @Input() allowMultipleFiles: boolean = false;
  private _allowedFileTypes: string[];

  @Input()
  get allowedFileTypes() {
    return this._allowedFileTypes;
  }

  set allowedFileTypes(allowed: string[]) {
    this._allowedFileTypes = allowed && allowed.map(a => a.toLowerCase());
  }

  constructor(private _elementref: ElementRef,
              private _renderer: Renderer2) {
  }

  @HostListener("change", ["$event"])
  readFiles(event) {
    if (event.target.files.length === 0) {
      this.imageSelectionCancelled.emit("Image deselected");
    }
    if (!this.allowMultipleFiles && event.target.files.length > 1) {
      const result: FileResult = {
        file: null,
        url: "",
        error: "Multiple files are not allowed"
      };
      this.imageSelected.emit(result);
      event.target.files = [];
      return;
    }
    for (const file of event.target.files as File[]) {
      const result: FileResult = {
        file: file,
        url: URL.createObjectURL(file)
      };
      let fileType: string = file.type;
      fileType = fileType && fileType.toLowerCase();
      if (fileType && this.allowedFileTypes && this.allowedFileTypes.length && this.allowedFileTypes.indexOf(fileType) === -1) {
        result.error = "File type not allowed";
        this.imageSelected.emit(result);
      }
      else {
        this.fileToDataURL(file, result)
          .then(r => this.imageSelected.emit(r))
          .catch(e => {
            result.error = "Image processing error";
            this.imageSelected.emit(result);
          });
      }
    }
  }

  private fileToDataURL(file: File, result: FileResult): Promise<FileResult> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = function(e) {
        result.dataURL = reader.result;
        resolve(result);
      };
      reader.readAsDataURL(file);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/file-upload.directive.ts